import { TargetControl } from './custom-ui.service'

export type DataSource = {
  id: string
  columnName: string
}

export type CustomizableDataSources = {
  [key: TargetControl]: DataSource[]
}

export const customizableDataSources: CustomizableDataSources = {
  assistantList: [
    {
      id: 'birthDate',
      columnName: 'Datum narození',
    },
    {
      id: 'coordinatorNote',
      columnName: 'Poznámka',
    },
  ],
}
